// Inline SVG monogram: serif "O" merged with ascending arrow + classical column.
export function LogoMark({ className = "h-9 w-9", gold = "#C5A059" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* O ring (open on the right) */}
      <path
        d="M40 8.5A24 24 0 1 0 40 55.5"
        stroke={gold}
        strokeWidth="5.5"
        strokeLinecap="round"
      />
      {/* ascending arrow / graph line */}
      <path
        d="M22 40 L31 31 L37 36 L50 20"
        stroke={gold}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M43 19 L51 19 L51 27" stroke={gold} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      {/* classical column shaft + base */}
      <rect x="38.5" y="38" width="2.4" height="12" fill={gold} />
      <rect x="43.2" y="38" width="2.4" height="12" fill={gold} />
      <rect x="36" y="35.5" width="12" height="2.6" fill={gold} />
      <rect x="35" y="50" width="14" height="2.8" fill={gold} />
    </svg>
  );
}

export function LogoFull({ compact = false, light = true }) {
  const nameColor = light ? "#F8F9FA" : "#0D1B2A";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark className={compact ? "h-8 w-8" : "h-10 w-10"} />
      <div className="leading-none">
        <div
          className="font-display font-extrabold tracking-[0.22em]"
          style={{ color: nameColor, fontSize: compact ? "1.05rem" : "1.2rem" }}
        >
          OPERA
        </div>
        <div className="font-display font-light tracking-[0.36em] text-[0.5rem] mt-0.5" style={{ color: "#C5A059" }}>
          REAL ESTATE PARTNERS
        </div>
      </div>
    </div>
  );
}
